import { render, staticRenderFns } from "./skeletonLoader.vue?vue&type=template&id=778ab7ae&scoped=true&"
import script from "./skeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./skeletonLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ab7ae",
  null
  
)

export default component.exports